import { useState, useEffect, useCallback } from 'react';

export function useExpenses(storage, year, month) {
  const [expenses, setExpenses] = useState([]);
  const [income, setIncomeState] = useState(0);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    const [data, inc] = await Promise.all([
      storage.getExpensesForMonth(year, month),
      storage.getIncome(year, month),
    ]);
    setExpenses(data);
    setIncomeState(inc);
    setLoading(false);
  }, [storage, year, month]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const addExpense = useCallback(
    async (data) => {
      await storage.addExpense(data);
      await refresh();
    },
    [storage, refresh]
  );

  const updateExpense = useCallback(
    async (expense) => {
      await storage.updateExpense(expense);
      await refresh();
    },
    [storage, refresh]
  );

  const deleteExpense = useCallback(
    async (id) => {
      await storage.deleteExpense(id);
      await refresh();
    },
    [storage, refresh]
  );

  const saveIncome = useCallback(
    async (amount) => {
      await storage.setIncome(year, month, amount);
      setIncomeState(amount);
    },
    [storage, year, month]
  );

  return { expenses, income, loading, addExpense, updateExpense, deleteExpense, saveIncome };
}
